export function correctDoubleSpaces(inputString: string) {
  // Use a regular expression to replace double spaces with a single space
  var correctedString = inputString.replace(/ {2,}/g, ' ');

  return correctedString;
}
